Promise.all([
  import(/* webpackMode: "eager" */ './see-and-do-widget.scss'),
  import('../../plugins/semantic/popup'),
  import('../../plugins/semantic/popup.css'),
  import('../../plugins/semantic/checkbox.css'),
  import('../../plugins/semantic/checkbox'),
  import('../../plugins/semantic/modal.scss'),
  import('../../plugins/semantic/modal'),
]).then(() => {
  $('.widget.see-and-do-widget').each(function (i, el) {
    $(el).data('widget', new SeeAndDoWidget(el))
    $(el).data('widget').init()
  })
})

function SeeAndDoWidget(el) {
  const self = this
  self.el = $(el)
  self.totalCount = 0
  self.offset = 0
  self.pageSize = parseInt($(el).attr('data-page-size'))
  self.allowedCategories = $(el).attr('data-explicit-category-ids')
    ? $(el).attr('data-explicit-category-ids').split(';')
    : null
  self.allowedStates = $(el).attr('data-explicit-state-ids') ? $(el).attr('data-explicit-state-ids').split(';') : null
  self.allowedParks = $(el).attr('data-explicit-park-ids') ? $(el).attr('data-explicit-park-ids').split(';') : null
  self.allowedJourney = $(el).attr('data-explicit-journey-id')
    ? $(el).attr('data-explicit-journey-id').split(';')[0]
    : null

  self.seeAndDoResults = require('./tab-see-and-do.hbs')

  self.showResults = function () {
    self.el.find('.secondary-button').popup('hide')
    self.el.find('.load-more-container').hide()

    const filters = {
      states: [],
      categories: [],
      allowedCategories: self.allowedCategories,
      allowedStates: self.allowedStates,
      allowedParks: self.allowedParks,
      allowedJourney: self.allowedJourney,
      offset: self.offset,
      pageSize: self.pageSize,
    }

    if (self.el.find('.filter-popup[data-button="state-button"] input:checked').length) {
      self.el.find('.filter-popup[data-button="state-button"] input:checked').each(function () {
        filters.states.push($(this).val())
      })
    }

    if (self.el.find('.filter-popup[data-button="categories-button"] input:checked').length) {
      self.el.find('.filter-popup[data-button="categories-button"] input:checked').each(function () {
        filters.categories.push($(this).val())
      })
    }

    $.ajax({
      url: $(el).attr('data-endpoint'),
      type: $(el).attr('data-method'),
      data: JSON.stringify(filters),
      dataType: 'json',
      contentType: 'application/json',
    })
      .done(function (data) {
        $.each(data.Results, function (i, result) {
          result.DatesMatch = result.StartDate === result.EndDate

          if (result.StartDate && !result.EndDate) {
            result.StartOnly = true
          }

          if (result.EndDate && !result.StartDate) {
            result.EndOnly = true
          }

          if (result.EndDate && result.StartDate) {
            result.BothDates = true
          }
        })

        if (data.Message.length) {
          self.el.find('.results').html('<div class="ui message">' + data.Message + '</div>')
        } else {
          var html = self.seeAndDoResults({
            data: data,
          })
          self.el.find('.results').append(html)

          if (data.TotalCount > data.Offset + data.PageSize) {
            self.el.find('.load-more-container').show()
          }
        }
      })
      .fail(function () {})
  }
  self.init = function () {
    if (process.env.NODE_ENV === 'development') {
      console.log('SeeAndDoWidget init', self)
    }
    self.el.css('opacity', 1)

    self.el.find('.filters-trigger').click(function (event) {
      event.preventDefault()
      $('.filter-modal[data-filter="' + $(this).attr('data-filter') + '"]').modal('show')
    })

    self.showResults()

    self.el.find('.ui.checkbox').checkbox()

    //self.offset = self.offset + self.pageSize;

    self.loadMore = function () {
      self.offset = self.offset + self.pageSize
      self.showResults()
    }

    self.el.find('.load-more').click(function (event) {
      event.preventDefault()
      self.loadMore()
    })

    self.el.find('.clear-filters').click(function (event) {
      event.preventDefault()
      self.el.find('.filter-popup input[type="checkbox"]').prop('checked', false)
      self.el.find('.filter .filtered').removeClass('filtered')
      self.el.find('.results').html('')
      self.offset = 0
      self.showResults()
    })

    self.el.find('.state-button').each(function (i, el) {
      $(el).popup({
        popup: self.el.find('.states-filters'),
        on: 'click',
        position: 'bottom center',
        lastResort: 'bottom center',
      })
    })

    self.el.find('.categories-button').each(function (i, el) {
      $(el).popup({
        popup: self.el.find('.category-filters'),
        on: 'click',
        position: 'bottom right',
        lastResort: 'bottom right',
      })
    })

    self.el.find('.apply-filters-button').click(function (e) {
      e.preventDefault()

      self.el.find('.results').html('')
      self.offset = 0

      self.showResults()
      self.el.find('.filter-popup').each(function (i, el) {
        var filterButton = self.el.find('.' + $(el).attr('data-button') + '')
        var filtersChecked = $(el).find('input:checked').length

        if (filtersChecked > 0) {
          filterButton.addClass('filtered')
          filterButton.find('.counter span').html(filtersChecked)
        } else {
          filterButton.removeClass('filtered')
        }
      })
    })
  }
}
